import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { AppHeader, SourceNote } from "@/components/Layout";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { formatDate, imageUrl } from "@/lib/blog";

export default function BlogCategory() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog/categories").then((rows) => setCat(rows.find((c) => c.slug === slug) || null));
    api.get(`/blog/posts?category=${encodeURIComponent(slug)}`).then(setPosts);
  }, [slug]);

  useSeo({
    title: cat ? `${cat.name} – blog category` : "Category",
    description: cat?.description || "Food Recall Alerts blog category",
    path: `/blog/category/${slug}`,
  });

  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <div className="mx-auto max-w-3xl px-5 py-10 sm:py-14" data-testid={`category-${slug}`}>
        <nav className="mb-6 text-xs text-slate-500">
          <Link to="/blog" className="hover:text-slate-900">Blog</Link>
        </nav>
        {cat ? (
          <header>
            <span className="inline-block rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide"
                  style={{ backgroundColor: `${cat.color}22`, color: cat.color }}>
              {cat.name}
            </span>
            <h1 className="mt-3 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">{cat.name}</h1>
            {cat.description && <p className="mt-2 text-slate-600">{cat.description}</p>}
          </header>
        ) : (
          <p className="text-slate-500">Category not found.</p>
        )}

        <ul className="mt-10 space-y-4">
          {posts.map((p) => (
            <li key={p.id} className="rounded-xl border border-slate-200 bg-white overflow-hidden sm:flex" data-testid={`category-post-${p.slug}`}>
              {p.hero_image && (
                <Link to={`/blog/${p.slug}`} className="block sm:w-48 sm:shrink-0">
                  <img src={imageUrl(p.hero_image)} alt="" className="h-full w-full object-cover" />
                </Link>
              )}
              <div className="p-5">
                <Link to={`/blog/${p.slug}`} className="font-display text-xl font-bold text-slate-900 hover:text-red-700">
                  {p.title}
                </Link>
                <p className="mt-1 text-xs text-slate-500">{formatDate(p.publish_date)}</p>
                <p className="mt-2 line-clamp-2 text-slate-600">{p.excerpt}</p>
              </div>
            </li>
          ))}
          {posts.length === 0 && <p className="text-slate-500">No posts in this category yet.</p>}
        </ul>
        <SourceNote className="mt-12" />
      </div>
    </div>
  );
}
